import RemaxService from '@/services/RemaxService';
import Vue from 'vue';
import Vuex from 'vuex';
import ListingUtil from '../../utils/ListingUtil';
import { Favourite } from '../../models/Favourite';

Vue.use(Vuex);

export interface FavouriteState {
    favouriteIds: number[];
    favourites: Favourite[];
    favouriteCount: number;
    favouriteNotifications: boolean;
}

export default {
    state: {
        favouriteIds: [],
        favourites: [],
        favouriteCount: 0,
        favouriteNotifications: true,
    } as FavouriteState,
    mutations: {
        SET_FAV_IDS(state: FavouriteState, favIds: number[]) {
            state.favouriteIds = favIds;
            state.favouriteCount = state.favouriteIds.length;
        },
        ADD_FAV_ID(state: FavouriteState, sysId: number) {
            if (state.favouriteIds.indexOf(sysId) === -1) {
                state.favouriteIds.push(sysId);
            }
            state.favouriteCount = state.favouriteIds.length;
        },
        REMOVE_FAV_ID(state: FavouriteState, sysId: number) {
            const index = state.favouriteIds.indexOf(sysId);
            if (index > -1) {
                state.favouriteIds.splice(index, 1);
            }
            state.favouriteCount = state.favouriteIds.length;
        },
        SET_FAVOURITES(state: FavouriteState, favs: Favourite[]) {
            state.favourites = favs;
        },
        ADD_FAVOURITE(state: FavouriteState, fav: Favourite) {
            state.favourites.push(fav);
        },
        REMOVE_FAVOURITE(state: FavouriteState, systemId: number) {
            state.favourites = state.favourites.filter((favourite: Favourite) => favourite.SystemId !== systemId );
        },
        CLEAR_FAVOURITES(state: FavouriteState) {
            state.favourites = [];
        },

        SET_FAV_NOTIFICATIONS(state: FavouriteState, isOn: boolean) {
            state.favouriteNotifications = isOn;
        },
    },
    actions: {
        getFavouriteSettings(context: any) {
            RemaxService.getFavouriteSettings()
            .then((response) => {
                if (context.state.favouriteIds && response.data && response.data.favourites) {
                    const allFavs = response.data.favourites;
                    const isNotifyOn = response.data.isNotifyOn;
                    // NOTE: There is a new property not yet used in web -> response.data.agent
                    // if the local favs don't match, sync up with server now
                    // NOTE this section can be removed after some time (added 2021-09-10)
                    if (context.state.favouriteIds.sort().join() !== response.data.favourites.sort().join()) {
                        const localFavsCopy = [...context.state.favouriteIds];
                        for (const favId of localFavsCopy) {
                            if (allFavs.indexOf(favId) === -1) {
                                allFavs.push(favId);
                                RemaxService.addFavouriteId(favId);
                            }
                        }
                        context.commit('SET_FAV_IDS', allFavs);
                        context.commit('SET_FAV_NOTIFICATIONS', isNotifyOn);
                    } else {
                        // server and local match
                        context.commit('SET_FAV_IDS', allFavs);
                        context.commit('SET_FAV_NOTIFICATIONS', isNotifyOn);
                    }
                }
            })
            .catch((error) => {
                console.error(error);
                context.dispatch('notify', 'Failed to get favs');
            });

        },
        setFavouriteNotifications(context: any, isOn: boolean) {
            context.commit('SET_FAV_NOTIFICATIONS', isOn);
            RemaxService.setFavouriteNotifications(isOn)
            .then((response) => {
                context.commit('SET_FAV_NOTIFICATIONS', isOn);
            })
            .catch((error) => {
                console.error(error);
                context.dispatch('notify', 'Failed to set favs notification');
            });
        },
        getFavoriteData(context: any) {
            context.commit('CLEAR_FAVOURITES');
            RemaxService.getFavourites()
            .then((response) => {
                console.log(response);
                const favs = response.data;
                const favList: Favourite[] = [];
                for (let i = 0; i < favs.length; i++) {
                    favList.push(new Favourite({
                        SystemId: favs[i].systemId,
                        PreviewImage: favs[i].previewImage,
                        Address: favs[i].address,
                        Price: ListingUtil.getFormatedPrice(favs[i].price),
                        Beds: favs[i].numBeds,
                        Baths: favs[i].numTotalBaths,
                        DOM: favs[i].daysOnMarket,
                        Status: ListingUtil.getStatusAsString(favs[i].listStatusCode.toString(), favs[i].classCode),
                        StatusCode: favs[i].listStatusCode.toString(),
                    }));
                }
                context.commit('SET_FAVOURITES', favList);
            })
            .catch((error) => {
                console.error(error);
                context.dispatch('notify', 'Failed to get favourites data');
            });
        },
        // EVENT_favourites_add
        favouriteAdd(context: any, systemId: number) {
            RemaxService.addFavouriteId(systemId)
            .then(() => {
                context.commit('ADD_FAV_ID', systemId);
            })
            .catch((error: any) => {
                console.error(error);
                context.dispatch('notify', 'Failed to add favourite data');
            });
        },
        // EVENT_favourites_remove
        favouriteRemove(context: any, systemId: number) {
            RemaxService.removeFavourite(systemId)
            .then((response) => {
                context.commit('REMOVE_FAV_ID', systemId);
                context.commit('REMOVE_FAVOURITE', systemId);
            })
            .catch((error) => {
                console.error(error);
                context.dispatch('notify', 'Failed to remove favourite');
            });
        },
    },
};
